import React, { PureComponent } from 'react'

// local components
import ShopTerminalItem from './ShopTerminalItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const ShopTerminalItemEditable = EditableHOCWrapper(ShopTerminalItem)

class ShopTerminalItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onTerminalUpdate(data, afterOnSave)
  }

  render() {
    const {
      terminal = {},
      lastModified = null,
      inventories = [],
      thirdPartyAccounts = [],
      defaultEditMode = false,
      onCancel,
      onDelete,
      blazePayPermission,
      posTerminals = [],
      refreshValidationList,
      validationList,
    } = this.props

    return (
      <ShopTerminalItemEditable
        dataToEdit={terminal}
        onSave={this.onSave}
        lastModified={lastModified}
        inventories={inventories}
        thirdPartyAccounts={thirdPartyAccounts}
        defaultEditMode={defaultEditMode}
        onCancel={onCancel}
        onDelete={onDelete}
        blazePayPermission={blazePayPermission}
        posTerminals={posTerminals}
        refreshValidationList={refreshValidationList}
        validationList={validationList}
      />
    )
  }
}

export default ShopTerminalItemContainer



// WEBPACK FOOTER //
// ./src/components/Terminals/ShopTerminalItemContainer.js